<mat-form-field>
    <mat-label>{{ "application" | transloco }}</mat-label>
    <mat-select #consumerFilter (valueChange)="onChangeEvent($event)">
        <mat-option [value]="">---</mat-option>
        @for (consumer of consumers; track consumer) {
            <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
        }
    </mat-select>
</mat-form-field>
